import { Reveal } from "@/components/common/Reveal";
import { Eyebrow } from "@/components/common/Section";

const REPORT = [
  { label: "The numbers", value: "12 inquiries · 5 viewings · 2 applications this week." },
  { label: "What viewers said", value: "\u201CLoved the light. Wished it had in-suite laundry.\u201D" },
  { label: "Our read", value: "Priced right. Laundry is the only recurring objection." },
  { label: "Recommendation", value: "Hold the price, add a portable washer. Signed by Thursday." },
];

export const Proof = () => {
  return (
    <section
      className="relative"
      style={{ backgroundColor: "#FFFFFF" }}
      data-nav-theme="light"
      data-testid="home-proof"
    >
      <div className="mx-auto max-w-[1440px] px-6 py-24 md:px-10 md:py-40">
        <div className="grid grid-cols-1 items-center gap-16 md:grid-cols-12 md:gap-10">
          {/* Pull-quote */}
          <div className="md:col-span-6">
            <Reveal>
              <Eyebrow>Proof, not promises</Eyebrow>
            </Reveal>
            <Reveal delay={0.05}>
              <div className="relative mt-8">
                <span
                  className="font-display absolute -left-1 -top-10 select-none"
                  style={{ color: "#C89A4E", fontSize: "120px", lineHeight: 1, opacity: 0.9 }}
                  aria-hidden="true"
                >
                  &ldquo;
                </span>
                <blockquote
                  className="font-display relative"
                  style={{ fontSize: "clamp(28px,3.4vw,46px)", color: "#201E1A", lineHeight: 1.14 }}
                >
                  First management company I've ever had that I don't chase. The Monday
                  report changed everything.
                </blockquote>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="label-caps mt-8 text-[11px]" style={{ color: "rgba(32,30,26,0.55)" }}>
                Portfolio owner · 3 doors · Bridgeland
              </p>
            </Reveal>
          </div>

          {/* Monday Report artifact */}
          <div className="md:col-span-6 md:pl-8">
            <Reveal delay={0.12}>
              <div
                className="relative mx-auto"
                style={{ maxWidth: 460, transform: "rotate(-2deg)" }}
                data-testid="monday-report"
              >
                <span
                  className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 rounded-full"
                  style={{ width: 14, height: 14, backgroundColor: "#C89A4E", boxShadow: "0 2px 6px rgba(0,0,0,0.25)" }}
                  aria-hidden="true"
                />
                <div
                  className="p-8"
                  style={{ backgroundColor: "#F8F5EF", borderRadius: 24, boxShadow: "0 30px 60px -20px rgba(20,35,27,0.35)" }}
                >
                  <div className="flex items-center justify-between border-b pb-4" style={{ borderColor: "rgba(32,30,26,0.12)" }}>
                    <span className="label-caps text-[12px]" style={{ color: "#24382E" }}>
                      Monday Report
                    </span>
                    <span className="label-caps text-[10px]" style={{ color: "rgba(32,30,26,0.5)" }}>
                      Mon · 10:00 AM
                    </span>
                  </div>
                  <p className="font-display mt-4" style={{ fontSize: "26px", color: "#24382E", lineHeight: 1 }}>
                    The Larchmont — Mission
                  </p>

                  <dl className="mt-6 space-y-5">
                    {REPORT.map((r) => (
                      <div key={r.label}>
                        <dt className="label-caps text-[10px]" style={{ color: "#C89A4E" }}>
                          {r.label}
                        </dt>
                        <dd className="mt-1 text-[15px]" style={{ color: "rgba(32,30,26,0.8)" }}>
                          {r.value}
                        </dd>
                      </div>
                    ))}
                  </dl>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Proof;
